import Cookies from "js-cookie";
import { useAuth0 } from "@auth0/auth0-react";
import { FormattedMessage, useIntl } from "react-intl";

import "./OnBoardingForm.scss";
import useToken from "hooks/useToken";
import usePermissions from "hooks/usePermissions";
import Button from "components/atoms/Button/Button";
import { ReactComponent as CargobaseLogoIcon } from "assets/images/icons/CargobaseLogo.svg";
import testIds from "constants/testIds";

function ActivationExpired() {
  const intl = useIntl();
  const { clearToken } = useToken();
  const { logout } = useAuth0();
  const { clearPermissions } = usePermissions();

  const handleRedirectLogin = () => {
    clearToken();
    clearPermissions();
    Cookies.remove("auth0_id_token");
    Cookies.remove("cargobase_logged_in_as_token");
    Cookies.remove("cargobase_usertoken");
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <div className="h-100 d-flex align-items-center">
      <div className="card-wrapper expire-card-wrapper p-18">
        <div>
          <CargobaseLogoIcon />
        </div>
        <div>
          <h3 className="mt-5">
            <FormattedMessage id="onboarding.linkExpired" defaultMessage="Link Expired" />
          </h3>
          <ul className="mt-3">
            <li>
              <FormattedMessage
                id="onboarding.expiredDescription1"
                defaultMessage="It seems like your invitation has expired"
              />
            </li>
            <li>
              <FormattedMessage
                id="onboarding.expiredDescription2"
                defaultMessage="If you have not joined yet, please ask your client to invite you again."
              />
            </li>
            <li>
              <FormattedMessage
                id="onboarding.expiredDescription3"
                defaultMessage="Otherwise, please proceed to the login page."
              />
            </li>
            <li>
              <FormattedMessage
                id="onboarding.expiredDescription4"
                defaultMessage="If you have any questions, don’t hesitate to contact us at"
              />{" "}
              <a href="mailto:support@cargobase.com">support@cargobase.com</a>
            </li>
          </ul>
        </div>

        <div className="mt-5 d-flex justify-content-center">
          <Button
            type="button"
            className="rounded-pill ml-auto font-b1 btn-size"
            label={intl.formatMessage({
              id: "onboarding.goToLoginPage",
              defaultMessage: "Go to login page",
            })}
            onClick={handleRedirectLogin}
            data-testid={testIds.ACTIVATION_EXPIRED_GO_TO_LOGIN}
          />
        </div>
      </div>
    </div>
  );
}

export default ActivationExpired;
